// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._n7zl18ew{border-bottom:var(--_m6cf7x)}._16jlidpf{flex-grow:0}
._16jlkb7n{flex-grow:1}
._16qs1qod{box-shadow:var(--_p4h2oc)}
._18u019bv{margin-left:10px}
._18u0r5cr{margin-left:var(--ds-space-negative-050,-4px)}
._19bvidpf{padding-left:0}
._1bahesu3{justify-content:flex-end}
._1e0c1txw{display:flex}
._1o9zidpf{flex-shrink:0}
._1o9zkb7n{flex-shrink:1}
._1wpz1h6o{align-self:center}
._2hwx1i6y{margin-right:var(--ds-space-negative-025,-2px)}
._4cvr1h6o{align-items:center}
._ca0q1skh{padding-top:11px}
._i0dl1wug{flex-basis:auto}
._i0dlf1ug{flex-basis:0%}
._n3td1crf{padding-bottom:9pt}
._otyr19bv{margin-bottom:10px}
._p12f3sup{max-width:285px}
._u5f319bv{padding-right:10px}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/emoji/dist/esm/components/common/EmojiActions.compiled.css"],"names":[],"mappings":";AACA,WAAW,4BAA4B,CAAC,WAAW,WAAW;AAC9D,WAAW,WAAW;AACtB,WAAW,yBAAyB;AACpC,WAAW,gBAAgB;AAC3B,WAAW,6CAA6C;AACxD,WAAW,cAAc;AACzB,WAAW,wBAAwB;AACnC,WAAW,YAAY;AACvB,WAAW,aAAa;AACxB,WAAW,aAAa;AACxB,WAAW,iBAAiB;AAC5B,WAAW,8CAA8C;AACzD,WAAW,kBAAkB;AAC7B,WAAW,gBAAgB;AAC3B,WAAW,eAAe;AAC1B,WAAW,aAAa;AACxB,WAAW,kBAAkB;AAC7B,WAAW,kBAAkB;AAC7B,WAAW,eAAe;AAC1B,WAAW,kBAAkB","sourcesContent":["\n._n7zl18ew{border-bottom:var(--_m6cf7x)}._16jlidpf{flex-grow:0}\n._16jlkb7n{flex-grow:1}\n._16qs1qod{box-shadow:var(--_p4h2oc)}\n._18u019bv{margin-left:10px}\n._18u0r5cr{margin-left:var(--ds-space-negative-050,-4px)}\n._19bvidpf{padding-left:0}\n._1bahesu3{justify-content:flex-end}\n._1e0c1txw{display:flex}\n._1o9zidpf{flex-shrink:0}\n._1o9zkb7n{flex-shrink:1}\n._1wpz1h6o{align-self:center}\n._2hwx1i6y{margin-right:var(--ds-space-negative-025,-2px)}\n._4cvr1h6o{align-items:center}\n._ca0q1skh{padding-top:11px}\n._i0dl1wug{flex-basis:auto}\n._i0dlf1ug{flex-basis:0%}\n._n3td1crf{padding-bottom:9pt}\n._otyr19bv{margin-bottom:10px}\n._p12f3sup{max-width:285px}\n._u5f319bv{padding-right:10px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
